module.exports = __webpack_public_path__ + "static/media/fly0061.2c89460f.webp";